import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PageNotFound from '../shared/PageNotFound';
import type { CovermeRouteEntry } from './routeConfig';

export const buildRoutesComponent = (allRoutes: CovermeRouteEntry[], effectiveIsAdmin: boolean, rootComponent: React.ReactElement) => {
  if (effectiveIsAdmin) {
    const adminRoutes = allRoutes
      .slice(1)
      .map(({ relativePaths, element }) =>
        relativePaths.map((relativePath: string) => (
          <Route key={`admin-${relativePath}`} path={relativePath} element={element} />
        ))
      )
      .flat();

    return (
      <Routes>
        <Route index element={rootComponent} />
        {adminRoutes}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    );
  }

  // For client mode, the "absolutePaths" in CovermeRouteEntry are actually already relative paths
  // that work correctly with BrowserRouter basename. The COVERME_ROUTES are paths like "/get-a-quote"
  // which React Router will match after removing the basename ("/travel-insurance")
  const clientRoutes = allRoutes
    .map(({ absolutePaths, element }) => 
      absolutePaths.map((path: string) => (
        <Route key={`client-${path}`} path={path} element={element} />
      ))
    )
    .flat();

  return (
    <Routes>
      {/* Add index route to redirect base path to the traveller details */}
      <Route index element={rootComponent} />
      {clientRoutes}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default buildRoutesComponent;
